/**
 * Kleines Status-/Kategorie-Abzeichen. Markup unverändert aus Preline.
 * Ton = feste, vollständige Klassenketten je Variante (nie zusammengesetzt).
 */
export type BadgeTon = "neutral" | "gedaempft" | "erfolg" | "primaer" | "fehler" | "warnung";

const TON_KLASSEN: Record<BadgeTon, string> = {
  neutral: "inline-flex items-center gap-x-1.5 py-0.5 px-2 rounded-full text-xs font-medium bg-surface text-surface-foreground",
  gedaempft: "inline-flex items-center gap-x-1.5 py-0.5 px-2 rounded-full text-xs font-medium bg-muted text-muted-foreground-1",
  erfolg:
    "inline-flex items-center gap-x-1.5 py-0.5 px-2 rounded-full text-xs font-medium bg-teal-100 text-teal-800 dark:bg-teal-500/20 dark:text-teal-400",
  primaer:
    "inline-flex items-center gap-x-1.5 py-0.5 px-2 rounded-full text-xs font-medium bg-primary-100 text-primary-800 dark:bg-primary-500/20 dark:text-primary-400",
  fehler:
    "inline-flex items-center gap-x-1.5 py-0.5 px-2 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-500/20 dark:text-red-400",
  warnung:
    "inline-flex items-center gap-x-1.5 py-0.5 px-2 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-500/20 dark:text-yellow-400",
};

export function Badge({ ton, children, label, punkt = false }: { ton: BadgeTon; children: React.ReactNode; label?: string; punkt?: boolean }) {
  return (
    <>
      {/* Preline: component/badge/badge-soft-color-variants */}
      <span className={TON_KLASSEN[ton]} aria-label={label}>
        {/* Abweichung AW-082 (2): Statuspunkt (additiv, Teilnehmer-Live P1, TQ6 a „Läuft“): ruhig, ohne Animation; nimmt die Textfarbe des Tons (`bg-current`, wie die Zustandspille); das Wort trägt die Aussage. */}
        {punkt && <span className="size-1.5 inline-block rounded-full bg-current" aria-hidden="true" />}
        {children}
      </span>
    </>
  );
}
